import { render, staticRenderFns } from "./PoliticaDePrivacidade.vue?vue&type=template&id=80b06298&scoped=true"
import script from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
import style0 from "./PoliticaDePrivacidade.vue?vue&type=style&index=0&id=80b06298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b06298",
  null
  
)

export default component.exports